// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_3a-6";
export var headerCell = "_3a-2";
export var rowWrapper = "_3a-4";
export var stickyAggregationCell = "_3a-a";
export var stickyAggregationRow = "_3a-7";
export var stickyColumnCell = "_3a-9";
export var stickyColumnHeaderCell = "_3a-8";
export var table = "_3a-1";
export var virtualRowWrapper = "_3a-5";
export var virtualTableContainer = "_3a-0";
export var white = "_3a-3";